// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountAdmin } from './account-admin';
import { AccountUser } from './account-user';
import { JobOrder } from './job-order';
import { Program } from './program';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountUserAllowanceLog extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get logType(): string {
    return 'ACCOUNT';
  }

  /**
   * Three kinds of row live in this table and only one of them is an adjustment. The sign alone
   * cannot tell them apart, and calling all of them "Adj." made a system draw read as something an
   * administrator did by hand - which cost a database dig on 2026-08-31 to explain one $93.52 row.
   *
   *   toJobOrderId    a debit: global credit spent covering an order that outran its program
   *                   allowance. Pairs with a "Covered by global allowance" row on the program side.
   *   fromProgramId   a credit: allowance left over on a program, carried into the global pot.
   *   neither         a genuine manual adjustment, which is the only case that says "Adj.".
   */
  get logTrx(): string {
    if (this.toJobOrderId) {
      return 'Applied to an Order Over-Allowance';
    }
    if (this.fromProgramId) {
      return 'Unused Program Allowance Added to Global';
    }
    if (this.amt < 0) {
      return 'Adj. to (+) Increase Your Global Allowance';
    } else {
      return 'Adj. to (-) Reduce Your Global Allowance';
    }
  }

  get debit(): number {
    if (this.amt > 0) {
      return this.amt;
    } else {
      return 0;
    }
  }

  get credit(): number {
    if (this.amt < 0) {
      return -this.amt;
    } else {
      return 0;
    }
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK accountAdmin */
  accountAdminId?: string;
  /** Guid FK accountUser */
  accountUserId!: string;
  /** String(2000) */
  adjustmentNote?: string;
  /** Decimal */
  amt!: number;
  /** Guid FK fromProgram */
  fromProgramId?: string;
  /** DateTimeOffset */
  logTs!: Date;
  /** Guid FK toJobOrder */
  toJobOrderId?: string;
  /** FK accountAdminId */
  accountAdmin!: AccountAdmin;
  /** FK accountUserId */
  accountUser!: AccountUser;
  /** FK fromProgramId */
  fromProgram!: Program;
  /** FK toJobOrderId */
  toJobOrder!: JobOrder;
}

